import Result from "@/core/common/Result";
import { EInsightsIASeverity } from "../../../@types/InsightsEnuns";
import { TAnaliseInteligenteInsightsStoreFiltros } from "../store/modules/InsightsDreAnaliseInteligente";

export type TObterRelatorioPayload = {
  idUsuario: string;
  IdDaEmpresa: string;

  //periodoId: string;
  //tipoAnalise: EInsightsIAAnalysisType;
};

export type TVerificarTermoUsoPayload = {
  versaoTermo: string;
};

export type TVerificarTermoUsoResponse = {
  DeveExibirModal: boolean;
  termoAceito: boolean;
  UrlDocumentoTermo: string;
  versaoTermo: string;
};

export type TObterInsightsRelatorioResponse = {
  quantidadeInsights: number;
  primeiraGeracao: boolean;
  criticos: number;
  atencao: number;
  infos: number;
  analises: TAnaliseInsight[];
};

export type TaceitarTermoPayload = {
  versaoTermo: string;
  urlDocumentoTermo: string;
};

export type TAvaliarInsightPayload = {
  idInsight: string;
  usefulInsight: boolean;
};

export type TAnaliseInsight = {
  id: string;
  order: number;
  title: string;
  severity: EInsightsIASeverity;
  summary: string;
  riskDescription: string;
  suggestedActions: string[];
  usefulInsight: boolean | null;
  isExpanded?: boolean;
};

export type TAvaliarInsightResponse = {
  quantidadeInsights?: number;
  criticos?: number;
  atencao?: number;
  infos?: number;
  analises: TAnaliseInsight[];
  primeiraGeracao?: boolean;

  analiseVertical?: boolean;
  competenciaAte?: string;
  competenciaDe?: string;
  dataCriacao?: string;
  disponivel?: boolean;
  id?: string;
  idEmpresa?: string;
  idModelo?: string;
  nomeFantasia?: string;
};

export type TTermoDeUsoResponse = {
  url: string;
  versao: string;
  dataAdicionado: Date;
};

export interface IDefaultInsightsIAResponse<T> {
  code: number;
  result: T;
  errors: { message: string }[] | null;
  errorType: string | null;
}

export type TAgenteDeDreResponse = {
  competenciaAte: string;
  id: string;
  idEmpresa: string;
  nomeFantasia: string;
  marca: number;
};

export type TObterConfiguracaoResponse = {
  idModeloDRE: string;
  agenteLigado: boolean;
  customerId: string;
  dataAtualizacao: string;
  diaGeracaoRelatorio: number;
  id: string;
  idUsuario: string;
  primeiraGeracao: boolean;
};

export type TAgenteDeDreFiltrosResponse = {
  id: string;
  idEmpresa: string;
  nomeFantasia: string;
  idModelo: string;
  competenciaDe: string;
  competenciaAte: string;
  dataCriacao: string;
  disponivel: boolean;
  analiseVertical: boolean;
  analises: TAnaliseInsight[];
};

export interface InsightsAIDreGateway {
  verificar(
    params: TVerificarTermoUsoPayload
  ): Promise<Result<TVerificarTermoUsoResponse>>;
  termoDeUso(): Promise<
    Result<IDefaultInsightsIAResponse<TTermoDeUsoResponse>>
  >;
  gerarRelatorio(): Promise<Result<TObterInsightsRelatorioResponse>>;
  aceitarTermo(
    params: TaceitarTermoPayload
  ): Promise<Result<IDefaultInsightsIAResponse<string | undefined>>>;
  avaliarInsight(
    params: TAvaliarInsightPayload
  ): Promise<Result<string | undefined>>;
  agenteDeDre(): Promise<Result<TAgenteDeDreResponse[]>>;
  agenteDeDreFiltros(
    filtros: TAnaliseInteligenteInsightsStoreFiltros
  ): Promise<Result<IDefaultInsightsIAResponse<TAvaliarInsightResponse>>>;
  obterConfiguracao(): Promise<Result<TObterConfiguracaoResponse>>;
}

export const InsightsAIDreGatewayDi = Symbol.for("InsightsAIDreGatewayDI");
